export default __webpack_public_path__ + "static/media/getting-started-4.09452b2a.png";